import { Node, NodeProps } from '@xyflow/react';
import { FC, memo } from 'react';
import { useTranslation } from 'react-i18next';

import { IconSvg } from '@/lib/v2/components';

import BinaryConditionalCard, { BinaryConditionalCardProps } from './BinaryConditionalCard';
import FilterCard from './FilterCard';

import { TRANSLATIONS } from '@/modules/AutomationModuleNew/constants/flows';
import { useHandleSidePanel } from '@/modules/AutomationModuleNew/hooks/Flows/useHandleSidePanel';
import { ConditionIcon } from '@/modules/AutomationModuleNew/icons/flows';
import { ConditionalNodeData } from '@/modules/AutomationModuleNew/types/flowsTypes';

export interface ConditionalNodeProps extends NodeProps<Node<ConditionalNodeData>> {
  onDelete?: (nodeId: string) => void;
}

const ConditionalNode: FC<ConditionalNodeProps> = (props) => {
  const { data, onDelete, id } = props;
  const { t } = useTranslation();
  const { handleOpenSidePanel } = useHandleSidePanel();

  const RenderSubTypeComponent = () => {
    if (data.type === 'binaryConditional') {
      const nodeProps: BinaryConditionalCardProps = props as BinaryConditionalCardProps;
      return <BinaryConditionalCard {...nodeProps} onEdit={handleOpenSidePanel} />;
    }
    if (data.type === 'filter') {
      return (
        <FilterCard
          borderColor="condition"
          data={data}
          editAction={{
            label: t('ConditionalNode.edit'),
            onClick: handleOpenSidePanel,
          }}
          icon={
            <IconSvg
              fillColor="sleepy"
              height="100%"
              svgComponent={<ConditionIcon />}
              width="100%"
            />
          }
          id={id}
          title={t(TRANSLATIONS.nodeTypes.filter)}
          onDelete={onDelete}
        />
      );
    }

    return null;
  };

  return <RenderSubTypeComponent />;
};

export default memo(ConditionalNode);
